// client/src/routes/AppRoutes.js
import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";

// Páginas de acceso inmediato (carga directa para evitar flashes)
import LoginPage from "../pages/LoginPage";
import RecuperarContrasenia from "../pages/RecuperarContrasenia";
import HomePage from "../pages/public/HomePage";
import NotFoundPage from "../pages/public/NotFoundPage";
import UnauthorizedPage from "../pages/public/UnauthorizedPage";
import Dashboard from "../pages/Dashboard";

// Code Splitting (Lazy Loading) para eliminar cuellos de botella de bundle en el POS
const DashboardInicio = lazy(() => import("../components/DashboardInicio"));
const RestaurantePage = lazy(() => import("../pages/RestaurantePage"));
const UsuariosPage = lazy(() => import("../pages/UsuariosPage"));
const ClientesPage = lazy(() => import("../pages/ClientesPage"));
const ProductosPage = lazy(() => import("../pages/ProductosPage"));
const MesasPage = lazy(() => import("../pages/MesasPage"));
const ReservasPage = lazy(() => import("../pages/ReservasPage"));
const PedidosPage = lazy(() => import("../pages/PedidosPage"));
const FacturaPage = lazy(() => import("../pages/FacturaPage"));
const InventarioPage = lazy(() => import("../pages/InventarioPage"));
const PublicacionesPage = lazy(() => import("../pages/PublicacionesPage"));
const ReseniasPage = lazy(() => import("../pages/ReseniasPage"));
const RedesSocialesPage = lazy(() => import("../pages/RedesSocialesPage"));

// Páginas públicas diferidas
const MenuPage = lazy(() => import("../pages/public/MenuPage"));
const PromocionesPage = lazy(() => import("../pages/public/PromocionesPage"));
const RestaurantesPage = lazy(() => import("../pages/public/RestaurantesPage"));
const ContactoPage = lazy(() => import("../pages/public/ContactoPage"));

// Spinner de transición elegante
const ModuleLoadingFallback = () => (
  <div className="flex items-center justify-center p-12 min-h-[300px]">
    <div className="flex flex-col items-center gap-3">
      <div className="w-10 h-10 border-4 border-amber-600 border-t-transparent rounded-full animate-spin"></div>
      <span className="text-gray-500 text-sm font-medium animate-pulse">Cargando módulo...</span>
    </div>
  </div>
);

export default function AppRoutes() {
  return (
    <Suspense fallback={<ModuleLoadingFallback />}>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/" element={<HomePage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/promociones" element={<PromocionesPage />} />
        <Route path="/restaurantes" element={<RestaurantesPage />} />
        <Route path="/contacto" element={<ContactoPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/recuperar-contraseña" element={<RecuperarContrasenia />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />

        {/* Rutas protegidas - Panel Administrativo / POS con Subrutas Anidadas */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute rolesPermitidos={["admin", "mesero"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardInicio />} />
          <Route path="restaurante" element={<RestaurantePage />} />
          <Route path="restaurantes" element={<RestaurantePage />} />
          <Route path="usuarios" element={<UsuariosPage />} />
          <Route path="clientes" element={<ClientesPage />} />
          <Route path="productos" element={<ProductosPage />} />
          <Route path="mesas" element={<MesasPage />} />
          <Route path="reservas" element={<ReservasPage />} />
          <Route path="pedidos" element={<PedidosPage />} />
          <Route path="ventas" element={<FacturaPage />} />
          <Route path="inventarios" element={<InventarioPage />} />
          <Route path="publicaciones" element={<PublicacionesPage />} />
          <Route path="resenias" element={<ReseniasPage />} />
          <Route path="resenas" element={<ReseniasPage />} />
          <Route path="redes-sociales" element={<RedesSocialesPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
